import Postel from '@/assets/companies/postel/footer-logo.svg?react';
import { ExternalDesignCompany } from '@/providers';
import { ReactNode } from 'react';

export const EXTERNAL_FOOTER_LOGOS: Record<ExternalDesignCompany, ReactNode> = {
  postel: <Postel className='h-[47px] w-auto' />,
};
